import { useContext } from 'react';

import { IContextMenuItem } from '@smartshell/ui-kit';
import { useNavigate } from 'react-router-dom';

import { TDeleteService } from 'hooks';
import { LocalizationContext } from 'localization';
import { openConfirmDialog } from 'services/Confirmation';
import notification from 'services/notificationService';
import { TService } from 'types';

import s from './ContextMenuItems.module.scss';

interface IUseContextMenuArgs {
  deleteService: TDeleteService;
}

export const useContextMenuItems = ({
  deleteService,
}: IUseContextMenuArgs): Array<IContextMenuItem<TService>> => {
  const { t } = useContext(LocalizationContext);
  const navigate = useNavigate();

  return [
    {
      key: 'edit',
      text: t('edit'),
      iconName: 'EditIcon',
      onClick: ({ id }) => {
        navigate(`/services/${id}`);
      },
    },
    {
      key: 'delete',
      className: s['remove-item'],
      text: t('delete'),
      iconName: 'BucketIcon',
      onClick: ({ id, title }) =>
        openConfirmDialog(t, 'remove', {
          title: t('service.deleting'),
          message: t('service.delete.confirm', title),
        })
          .then(({ status }) => {
            if (status === 'ACCEPTED') {
              return deleteService(id);
            }
          })
          .catch(() => {
            notification.info({
              t,
              type: 'error',
              title: t('service.delete.errors.title'),
              message: t('service.combo.error'),
            });
          }),
    },
  ];
};
